module.exports = __webpack_public_path__ + "static/media/cancel-gray.10c8212b.svg";